import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=7e3a8d8d&"
import script from "./CloseIcon.vue?vue&type=script&lang=ts&"
export * from "./CloseIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports